import { gql, useMutation } from '@apollo/client'

import agentClient from '@/lib/apollo/client/agent'
import type { WrappedMutation } from '@/lib/apollo/types'

const runCreditCheckMutation = gql`
  mutation runCreditCheck($customerId: String!, $subjectId: String!) {
    runCreditCheck(customerId: $customerId, subjectId: $subjectId)
  }
`

export type MutationVars = {
  customerId: string
  subjectId: string
}

export type RunCreditCheckData = {
  runCreditCheck: string | unknown
}

export const useRunCreditCheckMutation: WrappedMutation<
  RunCreditCheckData,
  MutationVars
> = () =>
  useMutation<RunCreditCheckData, MutationVars>(runCreditCheckMutation, {
    client: agentClient,
  })
